import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import PermissionGrantId = com.eidu.sharedlib.entity.permission.PermissionGrantId

export type GetPermissionGrantParameters = { id: PermissionGrantId }

const getPermissionGrant = async ({ id }: GetPermissionGrantParameters): Promise<PermissionGrantDTO | null> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants/${id.toString()}`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return permissionGrantDTO((await response.json()).document)
      case 404:
        console.warn(`Got status ${response.status} from getPermissionGrant endpoint`)
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getPermissionGrant endpoint`)
    }
  })
}

export default getPermissionGrant
